import React from "react";

const InfoCard = ({ title, amount, icon = null }) => {
  return (
    <div className="bg-white p-5 rounded-xl border border-gray-100 hover:border-gray-200 transition-colors">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-ink-muted mb-2">{title}</p>
          <p className="text-2xl font-semibold text-ink leading-none">{amount}</p>
        </div>
        {icon && (
          <div className="w-9 h-9 rounded-lg bg-primary-light flex items-center justify-center text-primary">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
